// extracted by mini-css-extract-plugin
module.exports = {"time":"CountdownTimer_time__H3e7y","spin":"CountdownTimer_spin__QUbw_","loader":"CountdownTimer_loader__pM9Px"};